import inventory from '@nextories/vue-core-components/src/i18n/langs/fr/inventory';

export default {
  ...inventory,
  title: 'Inventaire',
  empty: 'Votre inventaire est vide',
  button: 'Modifier mon inventaire',
  existVersion: {
    title: 'La dernière version de votre inventaire est en cours de validation',
    message: 'Pour voir la dernière version en cours de validation, cliqué sur le bouton « MODIFIER MON INVENTAIRE ».<br>Ci-dessous, vous trouverez votre ancien inventaire validé.',
  },
};
